import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { login02, loginlogo, logo, loginlogochange } from "../components/imagepath";
import { sendPasswordResetEmail } from "../services/authService";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgot = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const response = await sendPasswordResetEmail(email);
      setSuccess(response.message || "Reset link sent successfully.");
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Forgot Password | CRM</title>
      </Helmet>

      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            <div className="col-lg-6 login-wrap">
              <div className="login-sec">
                <div className="log-img">
                  <img
                    className="img-fluid"
                    src={login02}
                    alt="Login Background"
                    style={{ width: "80%", height: "auto" }}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div
                        className="account-logo"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <a href="/">
                          <img
                            // src={loginlogo}
                            // src={logo}
                            src={loginlogochange}
                            alt="Company Logo"
                            style={{ width: "180px", height: "auto" }}
                          />
                        </a>
                      </div>

                      <h2>Forgot Password</h2>
                      <p className="mb-4">
                        Enter your email to receive a reset link
                      </p>

                      {error && (
                        <div className="alert alert-danger">{error}</div>
                      )}
                      {success && (
                        <div className="alert alert-success">{success}</div>
                      )}

                      <form onSubmit={handleForgot}>
                        <div className="form-group">
                          <label>
                            Email <span className="login-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group login-btn">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Send Reset Link"}
                          </button>
                        </div>
                      </form>

                      <div className="next-sign">
                        <p className="account-subtitle">
                          Remember your password? <a href="/login">Login</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
